import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PaymentSchedule } from '../entities/db-stripe.model';
import { DashboardApiService } from './db-api.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardStripeApiService extends DashboardApiService {
  loadPaymentSchedule(): Observable<PaymentSchedule> {
    const referrer = location.host;
    return this._post('/v2/stripe/payment_schedule', { referrer }).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
